// extracted by mini-css-extract-plugin
module.exports = {"col":"AaSLbrJUqn56SeW2P1Hyd","container":"t8wtcI6YPPCK6-SDcg9n8","imageContainer":"_1LhvKoWghkjlL6bPASY70N","backgrund":"-f_s19eYiLij1zNkkAXgU","link":"_3oR_36sLlMp8mdg1bglYMJ"};